// Lista VIP (agenda social): amigos por nome, com quem está online, o level e onde está caçando.
import { useState } from 'preact/hooks';

export interface VipEntry { name: string; level: number; vocation: string; online: boolean; where: string }

const VOC_ICON: Record<string, string> = { knight: '🛡️', paladin: '🏹', sorcerer: '🔥', druid: '🌿', monk: '👊' };
const cap = (s: string) => (s ? s[0]!.toUpperCase() + s.slice(1) : '');

export function Vip(props: { st: { list: VipEntry[]; max: number } | null; send: (op: 'add' | 'remove', name: string) => void; onGuild: () => void }) {
  const [name, setName] = useState('');
  const [help, setHelp] = useState(false);
  if (!props.st) return <p class="muted">Carregando...</p>;
  const list = [...props.st.list].sort((a, b) => Number(b.online) - Number(a.online) || a.name.localeCompare(b.name));
  const online = list.filter((v) => v.online).length;
  const full = props.st.list.length >= props.st.max;
  const pct = Math.min(100, (props.st.list.length / Math.max(1, props.st.max)) * 100);
  const showHelp = help || !list.length;
  const add = () => { props.send('add', name.trim()); setName(''); };

  return (
    <div class="vp">
      <div class="vp-head">
        <div class="vp-book">📖</div>
        <div class="vp-head-txt">
          <div class="vp-title">Agenda Social <button class="vp-help" onClick={() => setHelp(!help)} title="Como funciona">?</button></div>
          <div class="vp-sub">Seus amigos de caça, quem está acordado e onde está lutando.</div>
        </div>
        <div class="vp-stats">
          <div class="vp-stat on" title="Amigos online agora"><b><i class="vp-dot" />{online}</b><small>online</small></div>
          <div class="vp-stat" title="Espaço na lista (VIP tem mais espaço)">
            <b>{props.st.list.length}<em>/{props.st.max}</em></b><small>amigos</small>
            <span class="vp-bar"><i style={{ width: pct + '%' }} /></span>
          </div>
        </div>
      </div>

      {showHelp && (
        <div class="vp-steps">
          <div><i>✍️</i><b>1. Anote o nome</b><small>Digite o nome exato do personagem e clique em Adicionar.</small></div>
          <div><i>🟢</i><b>2. Veja quem está online</b><small>Os online sobem para o topo, com o level e a hunt onde estão.</small></div>
          <div><i>🏰</i><b>3. Guild e Cerco</b><small>O botão Guild abre a sua guild, os membros e o Cerco.</small></div>
        </div>
      )}

      <div class="vp-add">
        <input class="mk-search" placeholder="Nome do personagem" value={name} maxLength={30}
          onInput={(e) => setName((e.target as HTMLInputElement).value)} onKeyDown={(e) => { if (e.key === 'Enter' && name.trim()) add(); }} />
        <button class="tb-button green" disabled={!name.trim()} onClick={add}>Adicionar</button>
        <button class="tb-button vp-guild" onClick={props.onGuild}>🏰 Guild</button>
      </div>
      {full && <div class="vp-full">Lista cheia ({props.st.max}). Tire alguém para adicionar outro amigo.</div>}

      <div class="vp-list">
        {list.map((v) => (
          <div key={v.name} class={'vp-card' + (v.online ? ' on' : '')}>
            <span class="vp-ava">{VOC_ICON[v.vocation] ?? '👤'}<i class="vp-dot" /></span>
            <div class="vp-info">
              <b>{v.name}</b>
              <small>{cap(v.vocation) || 'Vocation desconhecida'} · level {v.level || '?'}</small>
            </div>
            <span class={'vp-where' + (v.online ? '' : ' off')}>{v.online ? `⚔ ${v.where}` : 'offline'}</span>
            <button class="tb-button vp-rm" title="Tirar da lista" onClick={() => props.send('remove', v.name)}>Tirar</button>
          </div>
        ))}
        {!list.length && <p class="muted small vp-empty">Nenhum amigo na lista ainda. Anote o primeiro nome acima.</p>}
      </div>
    </div>
  );
}
